<template>
  <p class="text-center">
    <span class="me-3">{{ $tt('total_price') }}:</span>
    <PriceSpan :price="total" strong />
    <InfoIconTooltip class="info">
      {{ $tt('final_price_note') }}
    </InfoIconTooltip>
  </p>
</template>

<script setup lang="ts">
defineProps<{
  total: number;
}>();
</script>

<style scoped>
p {
  margin: 0;
  position: relative;
}
.info {
  position: absolute;
  top: -16px;
}
</style>